module.exports = __webpack_public_path__ + "img/宠物店.5c7e71e9.png";